import type { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import {
  faBell,
  faChartPie,
  faCubes,
  faGauge,
  faGear,
  faList,
  faStethoscope,
  faUsers,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { NavLink } from "react-router";
import { BASE } from "../lib/env";

interface Item {
  to: string;
  label: string;
  icon: IconDefinition;
}

interface Section {
  label: string;
  items: Item[];
}

const SECTIONS = (tenant: string): Section[] => [
  {
    label: "Operate",
    items: [
      { to: `/${tenant}`, label: "Overview", icon: faGauge },
      { to: `/${tenant}/sessions`, label: "Sessions", icon: faList },
      { to: `/${tenant}/projects`, label: "Projects", icon: faCubes },
      { to: `/${tenant}/users`, label: "Users", icon: faUsers },
    ],
  },
  {
    label: "Diagnose",
    items: [
      { to: `/${tenant}/conditions`, label: "Conditions", icon: faStethoscope },
      { to: `/${tenant}/analytics`, label: "Analytics", icon: faChartPie },
    ],
  },
  {
    label: "Manage",
    items: [
      { to: `/${tenant}/alerts`, label: "Alerts", icon: faBell },
      { to: `/${tenant}/settings`, label: "Settings", icon: faGear },
    ],
  },
];

export function SideNav({ tenant }: { tenant: string }) {
  return (
    <aside className="side-nav">
      <div className="brand">
        <img className="brand-logo" src={`${BASE}/longreach-logo.svg`} alt="" />
        <div className="brand-text">
          <strong>Longreach</strong>
          <small>Monitor · AI Operations</small>
        </div>
      </div>
      {SECTIONS(tenant).map((section) => (
        <div key={section.label} className="nav-section">
          <div className="nav-label">{section.label}</div>
          <nav>
            {section.items.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === `/${tenant}`}
                className={({ isActive }) => `nav-link ${isActive ? "active" : ""}`}
              >
                <FontAwesomeIcon icon={item.icon} className="nav-icon" fixedWidth />
                {item.label}
              </NavLink>
            ))}
          </nav>
        </div>
      ))}
    </aside>
  );
}
